export enum AttributeType {
  FIXED = 'FIXED',
  MIN_AND_MAX = 'MIN_AND_MAX',
  ONE_PER_OPT = 'ONE_PER_OPT',
}
